var UpdateRequestScreen = function() {
    var doubleclick_num = 0;

    function setSize() {
        //画像サイズ指定
        var imgW = 640;
        var imgH = 449;
        //ウィンドウサイズ取得
        var winW = $(window).width();
        var winH = $(window).height();

        var scaleW = winW / imgW;
        var scaleH = winH / imgH;
        var fixScale = Math.max(scaleW, scaleH);

        var setW = imgW * fixScale;
        var setH = imgH * fixScale;

        var moveX = Math.floor((winW - setW) / 2);
        var moveY = Math.floor((winH - setH) / 2);

        $('#bg').css({
            'width': setW,
            'height': setH,
            'left': moveX,
            'top': moveY
        });
    }

    // フォームの送信
    function submitForm() {
        if (doubleclick_num == 0) {
            doubleclick_num++;
            $('#loginForm').submit();
        }
    }

    var registerEvent = function() {
        $('[placeholder]').ahPlaceholder({
            placeholderColor: 'silver',
            placeholderAttr: 'placeholder',
            likeApple: false
        });

        $('#btSend').on('click touched', function() {
            submitForm();
        })
    };

    return {
        init: function() {
            setSize();

            registerEvent();
        },
        setSize: function() {
            setSize();
        }
    }
}();

$(function() {
    UpdateRequestScreen.init();
    //リサイズしたら実行
    $(window).resize(function() {
        UpdateRequestScreen.setSize();
    });
});
